import firebase from '@/firebase/firebase'
import { SetLeftFeature } from 'ag-grid-community';

const ref = firebase.firestore()

export async function toogleProductTypeStatus(companyId, productTypeId, productId, status) {

  const batch = ref.batch();

  const productRef = ref.collection('company').doc(companyId).collection('products').doc(productId);
  const productTypeRef = ref.collection('company').doc(companyId).collection('productType').doc(productTypeId);

  batch.update(productRef, { enabled : status });
  batch.update(productTypeRef, { [`products.${productId}.enabled`]: status });

  await batch.commit();
}

export default {
    methods: {
      toggleProductActive (product, productTypeId) {
        var pause   = product.enabled ? 'interromper' : 'retomar'; 
        let that = this; 
        
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: `Confirme a sua intenção`,
          text: `Tem certeza que deseja ${pause} a venda deste produto no menu?`,
          acceptText : 'Sim',
          cancelText : 'Não',
          accept: async () => {
            let companyId = that.$store.getters.getCompanyID

            try {
              this.$vs.loading();
              
              await toogleProductTypeStatus(companyId,
                productTypeId || product.productType.id,
                product.id,
                !product.enabled
              );
            } catch (err) {
              this.$vs.dialog({
                type: 'alert',
                color : 'primary',
                title : 'Erro!',
                acceptText : 'Fechar',
                text : `Houve um erro ao processar a sua requisição. ${err.message}`
              })
            } finally {
              this.$vs.loading.close()
            }
          }
        })
      },
      async duplicateProduct (product, productTypeId) {
        try {
          this.$vs.loading()
          const batch = ref.batch();
          let companyId = this.$store.getters.getCompanyID

          const originalProductSnap = await ref.collection('company').doc(companyId).collection('products').doc(product.id).get();

          const newProductRef = ref.collection('company').doc(companyId).collection('products').doc();

          batch.set(newProductRef, { ...originalProductSnap.data(), id: newProductRef.id });

          const productTypeRef = ref.collection('company').doc(companyId).collection('productType').doc(productTypeId);

          batch.update(productTypeRef, { [`products.${newProductRef.id}`]: { ...product, id: newProductRef.id } });

          await batch.commit();
        } catch (err) {
          this.$error({
            title: 'Erro inesperado',
            content : `Erro ao tentar dupicar produto. ${err.message}`
          });
        } finally {
          this.$nextTick(() => {
            this.$vs.loading.close()
          });
        }
      },

      async deleteProduct (productId, productTypeId) {

        var companyID = this.$store.getters.getCompanyID
        var self = this
        
        return new Promise((resolve, reject) =>{
          this.$confirm({
              zIndex : 9999999,
              title: 'Confirme a sua intenção',
              content: 'Deseja realmente remover este produto?',
              okText : 'Remover',
              cancelText : 'Não',
              okType: 'danger',
              async onOk () {
                try {
                  self.$vs.loading()
                  const batch = ref.batch();
                  
                  const productRef = ref.collection(`/company/${companyID}/products/`).doc(productId);
                  batch.delete(productRef);
                  const productTypeRef = ref.collection(`/company/${companyID}/productType`).doc(productTypeId);
                  batch.update(productTypeRef, {
                    [`products.${productId}`]: firebase.firestore.FieldValue.delete()
                  });
                  
                  await batch.commit();
                  resolve(true);
                } catch (err) {
                  self.$error({
                    title: 'Erro inesperado',
                    content : `Erro ao tentar excluir o produto. ${err.message}`
                  });
                  reject(err);
                } finally {
                  self.$nextTick(() => {
                    self.$vs.loading.close()
                  });
                }
              }
            })
          });
      },
    }
}